import { Dispatch, Action } from 'redux'
import { ReportMainMapDispatchReturnType } from './types/ReportMainMapDispatchReturnType'

export const ReportMainMapDispatch = (
  _dispatch: Dispatch<Action>
): ReportMainMapDispatchReturnType => {
  return {}
}
